module.exports = __webpack_public_path__ + "new-logo-white.png?0e5c8b935f90ff516ab9590b65e854fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/new-logo-white.png
// module id = 851
// module chunks = 0